module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAQAAAADQ4RFAAAAVklEQVR42mNgGCDwn/V//P/4/6ykaVrxHwQO/echRdOn/xBwmARt/9f+/0+ytv/8/0+MasOt7RDR0Y2iLZ52mshwHhkBMZy0kJs1yMqEZGV3cgoWGgIAJAAERizgy7gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/right-arrow.png
// module id = WzCs
// module chunks = 216